
export default {
    '3U': '四川航空',
    'TV': '西藏航空',
    'NS': '河北航空',
    'RY': '江西航空',
    'FM': '上海航空',
    'HO': '吉祥航空',
    'JR': '幸福航空',
    'BK': '奥凯航空',
    'HU': '海南航空',
    'DR': '瑞丽航空',
    'G5': '华夏航空',
    'FU': '福州航空',
    'SC': '山东航空',
    'YI': '英安航空',
    'HX': '香港航空',
    '8L': '祥鹏航空',
    'A6': '红土航空',
    'DZ': '东海航空',
    'MF': '厦门航空',
    'UQ': '乌鲁木齐航空',
    'CA': '中国航空',
    'OQ': '重庆航空',
    'KN': '中联航空',
    'GJ': '长龙航空',
    'QW': '青岛航空',
    'MU': '东方航空',
    '9C': '春秋航空',
    'CN': '大新华航',
    'GS': '天津航空',
    'GT': '桂林航空',
    'ZH': '深圳航空',
    'KY': '昆明航空',
    '9H': '长安航空',
    'EU': '成都航空',
    'GX': '北部弯航空',
    'GY': '多彩贵州航空',
    'CZ': '南方航空',
    'JD': '首都航空',
    'PN': '西部航空',
    'Y8': '扬子江快运航空',
};
